import { useState } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";

const contactMethods = [
  {
    icon: "fa-map-marker",
    label: "Office",
    title: "2522 Hunt Rd",
    detail: "Land O' Lakes, FL 34638",
    href: "https://www.google.com/maps/dir//brw+contracting/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x88c2bbfa4c781b39:0xdafff6d9ce08c51b?sa=X&ved=2ahUKEwiO5uTz9fT8AhW-TTABHXPFABoQ9Rd6BAhIEAU",
  },
  {
    icon: "fa-phone",
    label: "Phone",
    title: "(813) 996-5882",
    detail: "Mon-Fri, 8:00 AM - 5:00 PM",
    href: "tel:18139965882",
  },
  {
    icon: "fa-envelope",
    label: "Bid Requests",
    title: "bidrequests@brwcontracting.org",
    detail: "Project inquiries and estimating",
    href: "mailto:bidrequests@brwcontracting.org",
  },
  {
    icon: "fa-briefcase",
    label: "Careers",
    title: "careers@brwcontracting.org",
    detail: "Applications and resumes",
    href: "mailto:careers@brwcontracting.org",
  },
];

const Contact = () => {
  const [capVal, setCapVal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const sendEmail = (event) => {
    event.preventDefault();

    if (!capVal) {
      alert("Please complete the reCAPTCHA verification.");
      return;
    }

    setLoading(true);

    emailjs
      .sendForm(
        "service_8ailwss",
        "template_speslqg",
        event.currentTarget,
        "57rgEK2u3rLIDKJuO",
        {
          "g-recaptcha-response": capVal,
        }
      )
      .then(() => {
        event.currentTarget.reset();
        setCapVal(null);
        setShowSuccessModal(true);
      })
      .catch(() => alert("Something went wrong. Please try again later."))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Contact Us</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Homepage" href="/">
                      <i className="fa fa-house" /> &nbsp; Home
                    </a>
                  </span>
                  <span>Contact</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className="brw-contact">
        <section className="brw-contact__workspace">
          <div className="container">
            <div className="brw-contact__grid">
              <aside className="brw-contact__brief">
                <span className="brw-contact__eyebrow">Contact BRW</span>
                <h1>Let&apos;s Get The Right Person On It.</h1>
                <p>
                  Send project questions, bid requests, vendor inquiries, or
                  general messages directly to the BRW Contracting team.
                </p>

                <div className="brw-contact__brief-list">
                  <div>
                    <strong>Office Hours</strong>
                    <span>Mon-Fri: 8:00 AM - 5:00 PM</span>
                  </div>
                  <div>
                    <strong>Service Area</strong>
                    <span>Central Florida and surrounding areas</span>
                  </div>
                </div>
              </aside>

              <section className="brw-contact__form-card" aria-label="Contact form">
                <div className="brw-contact__form-head">
                  <span>Send A Message</span>
                  <h2>Tell Us What You Need</h2>
                </div>

                <form onSubmit={sendEmail} className="brw-contact__form">
                  {[
                    {
                      name: "user_name",
                      label: "Full Name",
                      type: "text",
                    },
                    {
                      name: "user_phone",
                      label: "Phone",
                      type: "text",
                    },
                    {
                      name: "user_email",
                      label: "Email",
                      type: "email",
                    },
                    {
                      name: "subject",
                      label: "Subject",
                      type: "text",
                    },
                  ].map((field) => (
                    <label className="brw-contact__field" key={field.name}>
                      <span>{field.label} *</span>
                      <input type={field.type} name={field.name} required />
                    </label>
                  ))}

                  <label className="brw-contact__field brw-contact__field--full">
                    <span>Your Message *</span>
                    <textarea name="message" rows="5" required />
                  </label>

                  <div className="brw-contact__footer">
                    <div className="brw-contact__captcha">
                      <ReCAPTCHA
                        sitekey="6LeqtMUpAAAAAME8SjXlQpSurZMUjSPGqZqNAOH5"
                        onChange={(val) => setCapVal(val)}
                        onExpired={() => setCapVal(null)}
                      />

                      {!capVal && (
                        <small>Please verify you&apos;re not a robot before sending.</small>
                      )}
                    </div>

                    <button type="submit" disabled={!capVal || loading}>
                      <span>{loading ? "Sending..." : "Send Message"}</span>
                      <i className="fa fa-paper-plane" aria-hidden="true"></i>
                    </button>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </section>

        <section className="brw-contact__destination">
          <div className="container">
            <div className="brw-contact__destination-panel">
              <div className="brw-contact__destination-head">
                <div>
                  <span>Contact Directory</span>
                  <h2>Reach The Right BRW Team</h2>
                </div>
              </div>

              <div className="brw-contact__method-grid">
                {contactMethods.map((method) => (
                  <a
                    className="brw-contact__method"
                    href={method.href}
                    target={method.href.startsWith("http") ? "_blank" : undefined}
                    rel={method.href.startsWith("http") ? "noreferrer" : undefined}
                    key={method.label}
                  >
                    <i className={`fa ${method.icon}`} aria-hidden="true"></i>
                    <div>
                      <span>{method.label}</span>
                      <strong>{method.title}</strong>
                      <small>{method.detail}</small>
                    </div>
                    <em className="fa fa-arrow-right" aria-hidden="true"></em>
                  </a>
                ))}
              </div>

              <div className="brw-contact__map-card">
                <div className="brw-contact__map-copy">
                  <span>Visit Us</span>
                  <h3>Land O&apos; Lakes Office</h3>
                  <p>2522 Hunt Rd, Land O&apos; Lakes, FL 34638</p>
                  <a
                    href="https://www.google.com/maps/dir//brw+contracting/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x88c2bbfa4c781b39:0xdafff6d9ce08c51b?sa=X&ved=2ahUKEwiO5uTz9fT8AhW-TTABHXPFABoQ9Rd6BAhIEAU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Get Directions
                    <i className="fa fa-location-arrow" aria-hidden="true"></i>
                  </a>
                </div>
                <div className="brw-contact__map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1027.0102706222422!2d-82.46876837324898!3d28.19403036810186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2bbfa4c781b39%3A0xdafff6d9ce08c51b!2sBRW%20Contracting%20Inc!5e0!3m2!1sen!2sus!4v1675276143283!5m2!1sen!2sus"
                    height={430}
                    width="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="BRW Location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {showSuccessModal && (
        <div
          className="brw-contact-modal"
          onClick={() => setShowSuccessModal(false)}
        >
          <div
            className="brw-contact-modal__card"
            role="dialog"
            aria-modal="true"
            aria-label="Message sent confirmation"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="fa fa-check-circle brw-contact-modal__icon"></i>
            <h4>Message Sent Successfully</h4>
            <p>Thanks for contacting us. We will reply soon.</p>
            <button type="button" onClick={() => setShowSuccessModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .brw-contact {
          background: #eef3f8;
          color: #061f3f;
        }

        .brw-contact,
        .brw-contact *,
        .brw-contact *::before,
        .brw-contact *::after {
          box-sizing: border-box;
        }

        .brw-contact .container {
          max-width: 1220px;
        }

        .brw-contact__workspace {
          padding: 64px 0 28px;
        }

        .brw-contact__grid {
          display: grid;
          grid-template-columns: minmax(300px, 0.38fr) minmax(0, 0.62fr);
          gap: 24px;
          align-items: stretch;
        }

        .brw-contact__brief,
        .brw-contact__form-card,
        .brw-contact__method,
        .brw-contact__map {
          border-radius: 8px;
          box-shadow: 0 24px 64px rgba(6, 31, 63, 0.1);
        }

        .brw-contact__brief {
          display: flex;
          min-height: 620px;
          flex-direction: column;
          justify-content: space-between;
          padding: 40px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.14) 0%, rgba(255, 173, 0, 0) 38%),
            #061f3f;
          color: #fff;
        }

        .brw-contact__eyebrow,
        .brw-contact__form-head span,
        .brw-contact__destination-head span,
        .brw-contact__map-copy span {
          display: inline-flex;
          width: fit-content;
          color: #ffad00;
          font-size: 0.74rem;
          font-weight: 800;
          letter-spacing: 0;
          line-height: 1.2;
          text-transform: uppercase;
        }

        .brw-contact__brief h1 {
          max-width: 420px;
          margin: 18px 0 0;
          color: #fff;
          font-size: clamp(2.15rem, 3.6vw, 3.7rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.03;
        }

        .brw-contact__brief p {
          max-width: 430px;
          margin: 22px 0 0;
          color: rgba(255, 255, 255, 0.78);
          font-size: 1rem;
          line-height: 1.7;
        }

        .brw-contact__brief-list {
          display: grid;
          gap: 12px;
          margin-top: 34px;
        }

        .brw-contact__brief-list div {
          padding: 16px;
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.08);
        }

        .brw-contact__brief-list strong,
        .brw-contact__brief-list span {
          display: block;
        }

        .brw-contact__brief-list strong {
          color: #ffad00;
          font-size: 0.82rem;
          font-weight: 800;
          text-transform: uppercase;
        }

        .brw-contact__brief-list span {
          margin-top: 5px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 0.94rem;
          line-height: 1.45;
        }

        .brw-contact__form-card {
          padding: 36px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.08) 0%, rgba(255, 255, 255, 0) 34%),
            #fff;
        }

        .brw-contact__form-head {
          margin-bottom: 24px;
          padding-bottom: 20px;
          border-bottom: 1px solid rgba(6, 31, 63, 0.1);
        }

        .brw-contact__form-head h2,
        .brw-contact__map-head h2 {
          margin: 8px 0 0;
          color: #061f3f;
          font-size: clamp(1.85rem, 3vw, 3.2rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.06;
        }

        .brw-contact__form {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 14px;
        }

        .brw-contact__field {
          display: flex;
          flex-direction: column;
          gap: 7px;
        }

        .brw-contact__field--full,
        .brw-contact__footer {
          grid-column: 1 / -1;
        }

        .brw-contact__field span {
          color: #061f3f;
          font-size: 0.78rem;
          font-weight: 800;
          letter-spacing: 0;
          line-height: 1.2;
          text-transform: uppercase;
        }

        .brw-contact__field input,
        .brw-contact__field textarea {
          width: 100%;
          min-height: 54px;
          padding: 13px 14px;
          border: 1px solid rgba(6, 31, 63, 0.14);
          border-radius: 6px;
          background: #f7f9fc;
          color: #061f3f;
          font-size: 1rem;
          outline: none;
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        }

        .brw-contact__field textarea {
          min-height: 150px;
          resize: vertical;
        }

        .brw-contact__field input:focus,
        .brw-contact__field textarea:focus {
          border-color: #ffad00;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(255, 173, 0, 0.14);
        }

        .brw-contact__footer {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(190px, 230px);
          gap: 16px;
          align-items: end;
          margin-top: 4px;
          padding: 16px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background: #f7f9fc;
        }

        .brw-contact__captcha {
          min-width: 0;
        }

        .brw-contact__captcha small {
          display: block;
          margin-top: 8px;
          color: #a92222;
          font-size: 0.82rem;
          font-weight: 700;
          line-height: 1.4;
        }

        .brw-contact__footer button,
        .brw-contact-modal__card button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-height: 54px;
          padding: 0 18px;
          border: 0;
          border-radius: 6px;
          background: linear-gradient(135deg, #ffbd2e 0%, #ff9f00 100%);
          color: #061f3f;
          font-size: 0.86rem;
          font-weight: 800;
          line-height: 1.2;
          text-transform: uppercase;
          box-shadow: 0 14px 32px rgba(255, 173, 0, 0.22);
          transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
        }

        .brw-contact__footer button:hover:not(:disabled),
        .brw-contact-modal__card button:hover {
          transform: translateY(-1px);
          box-shadow: 0 18px 38px rgba(255, 173, 0, 0.28);
        }

        .brw-contact__footer button:disabled {
          opacity: 0.56;
          cursor: not-allowed;
          box-shadow: none;
        }

        .brw-contact__destination {
          padding: 0 0 88px;
        }

        .brw-contact__destination-panel {
          position: relative;
          overflow: hidden;
          padding: 28px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.08) 0%, rgba(255, 255, 255, 0) 34%),
            #fff;
          box-shadow: 0 28px 80px rgba(6, 31, 63, 0.1);
        }

        .brw-contact__destination-panel::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #ffad00 0%, #061f3f 100%);
        }

        .brw-contact__destination-head {
          display: block;
          margin-bottom: 22px;
          padding-bottom: 22px;
          border-bottom: 1px solid rgba(6, 31, 63, 0.08);
        }

        .brw-contact__destination-head h2 {
          margin: 8px 0 0;
          color: #061f3f;
          font-size: clamp(2rem, 3.4vw, 3.25rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.02;
        }

        .brw-contact__method-grid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 14px;
        }

        .brw-contact__method {
          position: relative;
          display: grid;
          grid-template-columns: 42px 1fr 18px;
          gap: 14px;
          align-items: start;
          min-height: 142px;
          padding: 18px 16px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background:
            linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
          color: #061f3f;
          text-decoration: none;
          box-shadow: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
        }

        .brw-contact__method:hover {
          transform: translateY(-2px);
          border-color: rgba(255, 173, 0, 0.4);
          background: #fff;
          box-shadow: 0 18px 44px rgba(6, 31, 63, 0.12);
          color: #061f3f;
          text-decoration: none;
        }

        .brw-contact__method i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 6px;
          background: rgba(255, 173, 0, 0.16);
          color: #9d6500;
          font-size: 1rem;
        }

        .brw-contact__method em {
          align-self: center;
          color: rgba(6, 31, 63, 0.3);
          font-size: 0.78rem;
          font-style: normal;
          transition: color 0.2s ease, transform 0.2s ease;
        }

        .brw-contact__method:hover em {
          color: #ff9f00;
          transform: translateX(3px);
        }

        .brw-contact__method span,
        .brw-contact__method strong,
        .brw-contact__method small {
          display: block;
        }

        .brw-contact__method span {
          color: #ff9f00;
          font-size: 0.72rem;
          font-weight: 800;
          line-height: 1.2;
          text-transform: uppercase;
        }

        .brw-contact__method strong {
          margin-top: 7px;
          color: #061f3f;
          font-size: 0.98rem;
          font-weight: 800;
          line-height: 1.28;
          overflow-wrap: anywhere;
        }

        .brw-contact__method small {
          margin-top: 7px;
          color: #5b6b7d;
          font-size: 0.86rem;
          font-weight: 600;
          line-height: 1.45;
        }

        .brw-contact__map-card {
          display: grid;
          grid-template-columns: minmax(260px, 0.28fr) minmax(0, 0.72fr);
          gap: 0;
          overflow: hidden;
          margin-top: 18px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background: #061f3f;
          box-shadow: 0 24px 64px rgba(6, 31, 63, 0.12);
        }

        .brw-contact__map-copy {
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 430px;
          padding: 34px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.16) 0%, rgba(255, 173, 0, 0) 42%),
            #061f3f;
        }

        .brw-contact__map-copy h3 {
          margin: 10px 0 0;
          color: #fff;
          font-size: clamp(1.7rem, 2.5vw, 2.55rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.05;
        }

        .brw-contact__map-copy p {
          margin: 16px 0 24px;
          color: rgba(255, 255, 255, 0.78);
          font-size: 1rem;
          line-height: 1.6;
        }

        .brw-contact__map-copy a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: fit-content;
          min-height: 46px;
          padding: 0 18px;
          border-radius: 6px;
          background: #ffad00;
          color: #061f3f;
          font-size: 0.82rem;
          font-weight: 800;
          line-height: 1.2;
          text-transform: uppercase;
          text-decoration: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .brw-contact__map-copy a:hover {
          transform: translateY(-1px);
          box-shadow: 0 16px 34px rgba(255, 173, 0, 0.24);
          color: #061f3f;
          text-decoration: none;
        }

        .brw-contact__map {
          overflow: hidden;
          border-radius: 0;
          box-shadow: none;
          background: #061f3f;
        }

        .brw-contact__map iframe {
          display: block;
          width: 100%;
        }

        .brw-contact-modal {
          position: fixed;
          inset: 0;
          z-index: 2000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          background: rgba(6, 18, 34, 0.76);
          backdrop-filter: blur(8px);
        }

        .brw-contact-modal__card {
          width: min(100%, 440px);
          padding: 34px;
          border-radius: 8px;
          background: #fff;
          text-align: center;
          box-shadow: 0 26px 70px rgba(6, 31, 63, 0.22);
        }

        .brw-contact-modal__icon {
          margin-bottom: 16px;
          color: #2f9f66;
          font-size: 3rem;
        }

        .brw-contact-modal__card h4 {
          margin: 0;
          color: #061f3f;
          font-size: 1.55rem;
          font-weight: 800;
        }

        .brw-contact-modal__card p {
          margin: 12px 0 22px;
          color: #5b6b7d;
          line-height: 1.65;
        }

        .brw-contact-modal__card button {
          min-width: 150px;
        }

        @media (max-width: 1199px) {
          .brw-contact__method-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 991px) {
          .brw-contact__workspace {
            padding-top: 44px;
          }

          .brw-contact__grid {
            grid-template-columns: 1fr;
          }

          .brw-contact__brief {
            min-height: auto;
          }

          .brw-contact__map-card {
            grid-template-columns: 1fr;
          }

          .brw-contact__map-copy {
            min-height: auto;
          }
        }

        @media (max-width: 767px) {
          .brw-contact__workspace {
            padding-top: 34px;
          }

          .brw-contact__brief,
          .brw-contact__form-card,
          .brw-contact__destination-panel,
          .brw-contact__map-copy {
            padding: 24px;
          }

          .brw-contact__form,
          .brw-contact__footer,
          .brw-contact__method-grid {
            grid-template-columns: 1fr;
          }

          .brw-contact__footer {
            overflow: hidden;
          }

          .brw-contact__captcha {
            transform: scale(0.88);
            transform-origin: top left;
            width: 114%;
          }
        }
      `}</style>
    </>
  );
};

export default Contact;
